import React, { useState, useEffect, useContext } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styled from "styled-components";
import { Image } from "react-bootstrap";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import Markdown from "markdown-to-jsx";
import { markschemeTypeDictionary } from "../../helpers/pathDictionary";
import { FirebaseContext } from "../Firebase";
import OverridingChecklistComponent from "./overridingChecklist";
import CheckboxList from "../Checklist";


const Line = styled.div`
  height: 0px;
  background: black;
  margin-bottom: 10px;
`;

const SectionSubheading = styled.h2`
  font-size: 18px;
  text-indent: 15px;
  margin-top: 15px;
  text-decoration: underline;
  font-weight: 450;
`;

const SectionHeading = styled.h2`
  font-weight: 500;
  margin-top: 40px;
  margin-bottom: 20px;
  font-size: 20px;
  margin-bottom: 0;
  background-color: #ecebff;
  padding: 3px 13px;
  display: inline-block;
  border-radius: 10px;
`;

const None = styled.div`
  display: none;
`;

const AccordionContainer = styled.div`
  width: calc(65vw + 100px);
  white-space: pre-line;
  display: flex;
  flex-direction: column;
  strong {
    color: #4766cc;
  }
`;

const AdditionalResourcesWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ImageWrapper = styled.img`
  max-width: 100%;
`;

const MarkdownWrapper = styled.div`
  user-select: none;
  h3 {
    margin-top: 30px;
  }
`;

export default function SimpleAccordion(props) {
  const { user } = useContext(FirebaseContext);
  const [previousCode, setPreviousCode] = useState("");
  const markscheme = props.markscheme;
  const overriding_markscheme = props.overriding_markscheme;
  const additional_resources = props.additional_resources;
  const updateSectionCheck = props.updateSectionCheck;
  const updateTotalSectionCheck = props.updateTotalSectionCheck;
  const checkboxClicked = props.checkboxClicked;
  const disabled = props.disabled;

  var overriding_markscheme_objects = {};
  if (overriding_markscheme) {
    overriding_markscheme_objects = {
      intro: overriding_markscheme.block.filter((block) => {
        return block.strapi_component === "all-markschemes.introduction";
      }),
      pc: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "history-markschemes.presenting-complaint"
        );
      }),
      hpc: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component ===
          "history-markschemes.history-presenting-complaint"
        );
      }),
      pmh: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "history-markschemes.past-medical-history"
        );
      }),
      dh: overriding_markscheme.block.filter((block) => {
        return block.strapi_component === "history-markschemes.drug-history";
      }),
      ogh: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "history-markschemes.obstetric-history"
        );
      }),
      sexualh: overriding_markscheme.block.filter((block) => {
        return block.strapi_component === "history-markschemes.sexual-history";
      }),
      fh: overriding_markscheme.block.filter((block) => {
        return block.strapi_component === "history-markschemes.family-history";
      }),
      sh: overriding_markscheme.block.filter((block) => {
        return block.strapi_component === "history-markschemes.social-history";
      }),
      systems: overriding_markscheme.block.filter((block) => {
        return block.strapi_component === "history-markschemes.systems-review";
      }),
      ice: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component ===
          "history-markschemes.ideas-concerns-expectations"
        );
      }),
      conclusion: overriding_markscheme.block.filter((block) => {
        return block.strapi_component === "all-markschemes.conclusion";
      }),
      diagnosis: overriding_markscheme.block.filter((block) => {
        return block.strapi_component === "all-markschemes.diagnosis";
      }),
      investigations: overriding_markscheme.block.filter((block) => {
        return block.strapi_component === "all-markschemes.investigations";
      }),
      management: overriding_markscheme.block.filter((block) => {
        return block.strapi_component === "all-markschemes.management";
      }),
      questions: overriding_markscheme.block.filter((block) => {
        return block.strapi_component === "all-markschemes.questions";
      }),
      callHelp: overriding_markscheme.block.filter((block) => {
        return block.strapi_component === "abcde-markscheme.call_for_help";
      }),
      basicObs: overriding_markscheme.block.filter((block) => {
        return block.strapi_component === "abcde-markscheme.basic_observations";
      }),
      disability: overriding_markscheme.block.filter((block) => {
        return block.strapi_component === "abcde-markscheme.disability";
      }),
      breathing: overriding_markscheme.block.filter((block) => {
        return block.strapi_component === "abcde-markscheme.breathing";
      }),
      response: overriding_markscheme.block.filter((block) => {
        return block.strapi_component === "abcde-markscheme.response";
      }),
      circulation: overriding_markscheme.block.filter((block) => {
        return block.strapi_component === "abcde-markscheme.circulation";
      }),
      danger: overriding_markscheme.block.filter((block) => {
        return block.strapi_component === "abcde-markscheme.danger";
      }),
      airway: overriding_markscheme.block.filter((block) => {
        return block.strapi_component === "abcde-markscheme.airway";
      }),
      exposure: overriding_markscheme.block.filter((block) => {
        return block.strapi_component === "abcde-markscheme.exposure";
      }),
      reflexes: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component ===
          "neurological-examination-markschemes.reflexes"
        );
      }),
      coordination: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component ===
          "neurological-examination-markschemes.coordination"
        );
      }),
      specialTests: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component ===
          "neurological-examination-markschemes.special-tests"
        );
      }),
      CN11: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component ===
          "neurological-examination-markschemes.cn-xi"
        );
      }),
      CN8: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component ===
          "neurological-examination-markschemes.cn-viii"
        );
      }),
      CN1: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "neurological-examination-markschemes.cn-i"
        );
      }),
      CN346: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component ===
          "neurological-examination-markschemes.cn-iii-iv-vi"
        );
      }),
      sensation: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component ===
          "neurological-examination-markschemes.sensation"
        );
      }),
      CN2: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component ===
          "neurological-examination-markschemes.cn-ii"
        );
      }),
      tone: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "neurological-examination-markschemes.tone"
        );
      }),
      CN5: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "neurological-examination-markschemes.cn-v"
        );
      }),
      CN7: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component ===
          "neurological-examination-markschemes.cn-vii"
        );
      }),
      power: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component ===
          "neurological-examination-markschemes.power"
        );
      }),
      CN91012: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component ===
          "neurological-examination-markschemes.cn-ix-x-xii"
        );
      }),
      inspection: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component ===
          "examination-general-markschemes.inspection"
        );
      }),
      percussion: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component ===
          "examination-general-markschemes.percussion"
        );
      }),
      auscultation: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component ===
          "examination-general-markschemes.auscultation"
        );
      }),
      face: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "examination-general-markschemes.face"
        );
      }),
      look: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "examination-general-markschemes.look"
        );
      }),
      neck: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "examination-general-markschemes.neck"
        );
      }),
      palpation: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "examination-general-markschemes.palpation"
        );
      }),
      feel: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "examination-general-markschemes.feel"
        );
      }),
      hands: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "examination-general-markschemes.hands"
        );
      }),
      move: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "examination-general-markschemes.move"
        );
      }),
      presentation: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component ===
          "examination-general-markschemes.presentation"
        );
      }),
      findings: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "examination-general-markschemes.findings"
        );
      }),
      gait: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "neurological-examination-markschemes.gait"
        );
      }),
      function: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "examination-general-markschemes.function"
        );
      }),
      ankles: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "examination-general-markschemes.ankles"
        );
      }),
      chest: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "examination-general-markschemes.chest"
        );
      }),
      legs: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "examination-general-markschemes.legs"
        );
      }),
      back: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "examination-general-markschemes.back"
        );
      }),
      speculum: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "examination-general-markschemes.speculum"
        );
      }),
      groin: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "examination-general-markschemes.groin"
        );
      }),
      abdomen: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "examination-general-markschemes.abdomen"
        );
      }),
      when: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "explanation-markscheme.when"
        );
      }),
      why: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "explanation-markscheme.why"
        );
      }),
      what: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "explanation-markscheme.what"
        );
      }),
      how: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "explanation-markscheme.how"
        );
      }),
      benefits: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "explanation-markscheme.benefits"
        );
      }),
      before: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "explanation-markscheme.before"
        );
      }),
      other: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "explanation-markscheme.other"
        );
      }),
      during: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "explanation-markscheme.during"
        );
      }),
      contraindications: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "explanation-markscheme.contraindications"
        );
      }),
      after: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "explanation-markscheme.after"
        );
      }),
      prognosis: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "explanation-markscheme.prognosis"
        );
      }),
      risks: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "explanation-markscheme.risks"
        );
      }),
      description: overriding_markscheme.block.filter((block) => {
        return (
          block.strapi_component === "explanation-markscheme.description"
        );
      }),
    };
  }

  const objects = overriding_markscheme && overriding_markscheme_objects;
  var prev = "";

  return (
    <>
      <AccordionDetails>
        <Typography>
          {overriding_markscheme == null &&
            markscheme.map((section, index) => {
              return (
                <div key={`section-${section.section_title}-${index}`}>
                  <SectionHeading>{section.section_title}</SectionHeading>
                  <Line />
                  <CheckboxList
                    points={section.points}
                  />
                  <br />
                </div>
              );
            })}
          {overriding_markscheme != null && (
            <>
              {overriding_markscheme.block.map((section, index) => {
                return (
                  <React.Fragment key={`overriding-section-${section.strapi_component}-${index}`}>
                    <OverridingChecklistComponent
                      checkboxClicked={checkboxClicked}
                      section={section}
                      previousCode={prev}
                      updateSectionCheck={updateSectionCheck}
                      sectionCode={section.strapi_component}
                      updateTotalSectionCheck={updateTotalSectionCheck}
                      disabled={disabled}
                    />
                    <None>{(prev = section.strapi_component)}</None>
                  </React.Fragment>
                );
              })}
            </>
          )}
        </Typography>
      </AccordionDetails>
    </>
  );
}
